import { IconTypesProps } from '@/ui/components/svg/iconTypes'
import { Circle, Path, Svg } from '@react-pdf/renderer'

const SvgStatusResolved = ({ primaryColor = '#FFFFFF' }: IconTypesProps) => (
    <Svg width="20" height="20" viewBox="0 0 24 24">
        <Circle cx="12" cy="12" r="12" fill="#CCCCCC" />
        <Path
            d="M10.1367 14.9609L17.6133 7.49609L18.1523 8.03516L10.1367 16.0508L6 11.9023L6.53906 11.3633L10.1367 14.9609Z"
            fill={primaryColor}
        />
    </Svg>
)

export default SvgStatusResolved
